import { Cookies } from 'react-cookie';

export const getZzSessionData = (key?: string) => {
  const cookies = new Cookies();

  const zzSessionDataCookie = cookies.get('zz_session_data');
  if (!zzSessionDataCookie) {
    return {};
  }
  const parsedData = JSON.parse(decodeURI(cookies.get('zz_session_data')));

  if (key) {
    return parsedData[key] || {};
  }

  return parsedData;
};

export const addZzSessionData = (updateData?: { name?: string; value?: Record<string, unknown> }) => {
  if (!updateData) {
    return;
  }
  const cookies = new Cookies();

  const zzSessionData = getZzSessionData();
  zzSessionData[`${updateData.name}`] = updateData.value;
  cookies.set('zz_session_data', encodeURI(JSON.stringify(zzSessionData)), {
    path: '/',
    domain: 'zigzag.kr',
  });
};

export const removeZzSessionData = (removeDataKey?: string) => {
  // session data 에서 특정 key 데이터 제거
  if (!removeDataKey) {
    return;
  }
  const cookies = new Cookies();

  const zzSessionData = getZzSessionData();
  delete zzSessionData[`${removeDataKey}`];
  cookies.set('zz_session_data', encodeURI(JSON.stringify(zzSessionData)), {
    path: '/',
    domain: 'zigzag.kr',
  });
};
